import React from "react";
import PropTypes from "prop-types";
import { fetchQuery } from "relay-runtime";

import clsx from "clsx";

import withStyles from "@material-ui/core/styles/withStyles";

import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";

import NavContent from "./NavContent";

import { StateContext } from "./context";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import initialValuesQuery from "./initialValuesQuery";
const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent);

const drawer_width = 300;

const styles = theme => {
  return {
    drawer: {
      width: drawer_width,
      flexShrink: 0,
      whiteSpace: "nowrap"
    },
    drawerOpen: {
      width: drawer_width,
      transition: theme.transitions.create(["width"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      })
    },
    drawerClose: {
      transition: theme.transitions.create(["width"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      }),
      //transition: 'width 1.3s cubic-bezier(0.4, 0, 0.2, 1)',
      overflowX: "hidden",
      width: 80,
      border: "none",
      borderRight: "1px solid #EEE"
    },
    container: {
      width: `calc(100% - 80px)`,
      margin: 0,
      marginLeft: 80,
      // border: "16px solid",
      padding: 16,
      // overflow: "hidden",
      minHeight: "100vh",
      background: theme.palette.whiteGrey,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      })
    },
    container_open: {
      marginLeft: drawer_width,
      width: `calc(100% - ${drawer_width}px)`,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      })
    }
  };
};

const handleResize = (matches_value, controlled_value) => {
  const is_controlled = isBool(controlled_value);
  const matches = is_controlled
    ? matches_value && controlled_value
    : matches_value;
  return {
    small_menu_open: is_controlled && !matches_value ? controlled_value : false,
    big_menu_open: matches,
    matches
  };
};

function isBool(value) {
  return Boolean(value !== null && value !== undefined);
}

const NavDrawer = ({
  children,
  classes: { drawer, drawerClose, drawerOpen, container, container_open },
  open: controlled_drawer_value,
  onSelect,
  onSelectOrg,
  onSelectProperty,
  initialValue,
  initialIDValue,
  ...props
}) => {
  const [selected_org, setOrg] = React.useState();
  const [orgsList, setOrgs] = React.useState([]);
  const [selected_property, setProperty] = React.useState({});

  const is_controlled = React.useMemo(() => isBool(controlled_drawer_value), [
    controlled_drawer_value
  ]);

  async function setListOfOrgs() {
    const { authorizedOrgs } = await fetchQuery(
      props.environment,
      initialValuesQuery,
      { name: "", first: 1000, appName: "Events" }
    );
    setOrgs(authorizedOrgs);
  }
  // set the default value //
  React.useEffect(() => {
    // if (initialIDValue) {
    //   getInitialValues(initialIDValue)
    //   setLoading(false)
    // }
    const { org, ...selected_suborg } = initialValue;
    setOrg(org);
    if (selected_suborg.id === initialIDValue) {
      setProperty(selected_suborg);
    }
    setListOfOrgs();
  }, [initialIDValue, initialValue]);

  // ------------------------------ resize - toggle nav ------------------------------ //

  const matches = useMediaQuery("(min-width:1280px)");

  const [state, set] = React.useState(
    handleResize(matches, controlled_drawer_value)
  );

  function toggleDrawer() {
    if (is_controlled) {
      return;
    } else {
      const drawer = matches ? "big_menu_open" : "small_menu_open";
      set({ ...state, [drawer]: !state[drawer] });
      localStorage.setItem("drawer", !state[drawer]);
    }
  }

  const { big_menu_open, small_menu_open } = state;

  React.useEffect(() => {
    if (state.matches !== matches) {
      set(handleResize(matches, controlled_drawer_value));
    } else if (is_controlled) {
      const drawer = matches ? "big_menu_open" : "small_menu_open";
      set({ ...state, [drawer]: controlled_drawer_value });
    }
  }, [matches, is_controlled, controlled_drawer_value]);

  // -------------------------------------------------------------------------------- //
  // ------------------------------ select_org_property ------------------------------ //

  function select_org_property(new_value, type) {
    if (type === "org") {
      setOrg(new_value);
      setProperty({});
      if (typeof onSelectOrg === "function") {
        onSelectOrg(new_value);
      }
    }

    if (type === "property") {
      setOrg(new_value[0]);
      setProperty(new_value[1]);

      if (typeof onSelectProperty === "function") {
        onSelectProperty(new_value);
      }
    }

    if (typeof onSelect === "function") {
      onSelect({ ...selected_org, ...selected_property, pressed: type });
    }

    if (!matches) {
      toggleDrawer(false);
    }
  }

  // -------------------------------------------------------------------------------- //
  return (
    <>
      <StateContext.Provider value={(selected_org, selected_property)}>
        <div
          className={clsx(container, {
            [container_open]: big_menu_open
          })}
        >
          <div style={{ minHeight: "calc(100vh - 32px)", position: "relative" }}>
            {React.cloneElement(children, {
              toggleDrawer,
              selected_org,
              selected_property
            })}
          </div>
        </div>
        <Hidden lgUp implementation="css">
          <SwipeableDrawer
            disableBackdropTransition={!iOS}
            disableDiscovery={iOS}
            variant="temporary"
            open={small_menu_open}
            onClose={e => toggleDrawer(false)}
            onOpen={e => toggleDrawer(true)}
          >
            <NavContent
              {...props}
              menu_open={small_menu_open}
              onClose={e => toggleDrawer(false)}
              select_org_property={select_org_property}
              selected_org={selected_org}
              selected_property={selected_property}
              orgs={orgsList}
              swipeable
            />
          </SwipeableDrawer>
        </Hidden>
        <Drawer
          variant="permanent"
          open
          className={clsx(drawer, {
            [drawerOpen]: big_menu_open,
            [drawerClose]: !big_menu_open
          })}
          classes={{
            paper: clsx({
              [drawerOpen]: big_menu_open,
              [drawerClose]: !big_menu_open
            })
          }}
        >
          <NavContent
            {...props}
            menu_open={big_menu_open}
            onClose={e => toggleDrawer(false)}
            select_org_property={select_org_property}
            selected_org={selected_org}
            selected_property={selected_property}
            orgs={orgsList}
          />
        </Drawer>
      </StateContext.Provider>
    </>
  );
};

NavDrawer.propTypes = {
  classes: PropTypes.shape({
    drawer: PropTypes.string.isRequired,
    drawerClose: PropTypes.string.isRequired,
    drawerOpen: PropTypes.string.isRequired
  }),
  children: React.isValidElement,
  pathname: PropTypes.string.isRequired
};

NavDrawer.defaultProps = {
  children: <div></div>,
  pathname: "/"
};

export default React.memo(withStyles(styles)(NavDrawer));